/** @format */
import { TFunction } from 'next-i18next';
import { FunctionComponent } from 'react';

import BatteryChargeCountSVG from '@toucan/client/global/icons/battery-charge-count.svg';
import FirmwareVersionSVG from '@toucan/client/global/icons/firmware-version.svg';
import HourCountSVG from '@toucan/client/global/icons/hour-count.svg';
import ShutterCountSVG from '@toucan/client/global/icons/shutter-count.svg';

import { formatAsDecimal } from '@toucan/client/global/currency';
import { Market } from '@toucan/client/global/market';
import {
    AttributeKey,
    ProductSummaryAttribute,
    isUsageAttribute,
} from '@toucan/client/global/product';

export const getFormattedAttributeContent = (
    { iso }: Market,
    { name, content }: ProductSummaryAttribute
) => {
    const isNumber = isUsageAttribute(name);

    if (!isNumber) {
        return content;
    }

    return formatAsDecimal(iso, Number(content));
};

export const getAttributePrefix = (
    t: TFunction,
    attributeKey: AttributeKey
) => {
    switch (attributeKey) {
        case AttributeKey.SHUTTER_COUNT:
            return t('Shutter count');
        case AttributeKey.BATTERY_CHARGE_COUNT:
            return t('Battery charge count');
        case AttributeKey.HOUR_COUNT:
            return t('Hour count');
        case AttributeKey.FIRMWARE:
            return t('Firmware version');
        default:
            return null;
    }
};

export const getAttributeIcon = (
    attributeKey: AttributeKey
): FunctionComponent => {
    switch (attributeKey) {
        case AttributeKey.SHUTTER_COUNT:
            return ShutterCountSVG;
        case AttributeKey.BATTERY_CHARGE_COUNT:
            return BatteryChargeCountSVG;
        case AttributeKey.HOUR_COUNT:
            return HourCountSVG;
        case AttributeKey.FIRMWARE:
            return FirmwareVersionSVG;
        default:
            return () => null;
    }
};
